/**
 * The number of hours contains in a single day
 * @type {number}
 */
export const HOURS_IN_DAY = 24;
